var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"page-sub-footer",class:[!_vm.flush && 'mt-4']},[_c('div',{staticClass:"page-sub-footer__alert",class:[_vm.flushAlert && 'mb-0']},[_vm._t("before")],2),_c('nav',{staticClass:"page-sub-footer__nav",class:[_vm.right && 'page-sub-footer__nav--right']},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }